import { metricNames } from '@linearb/linjs-common';

export const DASHBOARD_DEBOUNCE_PRIORITY = {
  HIGH: 1000,
  MEDIUM: 2000,
  LOW: 3000
};

export const TEAM_RETROSPECT_METRICS = [
  metricNames.REVIEWS,
  metricNames.REVIEW_DEPTH,
  metricNames.RELEASES_COUNT
];

export const DEFAULT_REQUESTED_TEAM_METRICS = [
  metricNames.TIME_TO_PR,
  metricNames.TIME_TO_REVIEW,
  metricNames.REVIEW_TIME,
  metricNames.TIME_TO_PROD,
  metricNames.ACTIVE_BRANCHES,
  metricNames.DONE_BRANCHES,
  metricNames.REVIEWS,
  metricNames.ACTIVE_DAYS,
  metricNames.NEW_WORK,
  metricNames.REWORK,
  metricNames.REFACTOR,
  metricNames.COMMIT_CODE_CHANGES,
  metricNames.REVIEW_DEPTH,
  metricNames.RELEASES_COUNT
];

export const LAST_5_ITERATIONS_METRICS = [
  metricNames.COMMIT_CODE_CHANGES,
  metricNames.RELEASES_COUNT,
  metricNames.PR_MERGED,
  metricNames.PR_NEW,
  metricNames.ACTIVE_CONTRIBUTORS
];
export const RELEASES_DEFAULT_SETTINGS = {
  emptyStateLink: '/settings/organization',
  linkText: 'Change the way releases are detected',
  descriptionText: 'Can’t see your releases?'
};

export const cycleTimeGridSize = 6;
